import React from 'react'

/* Styles */
import './PublicChamps.css'

//Modules
import { List, Card, Input } from 'antd'
import { Link } from 'react-router-dom';

const PublicChampsView = (props) => {
    return (
        <div className='publicChampsCentralDiv'>
            <a id="champs"><div style={{ height: '80px' }} /></a>

            <div className='publicHomeAdSense'></div>

            <div className='publicChampsBody'>
                <h4>Campeonatos</h4>

                <div className='publicChampsSearchContainer'>
                    <div className='publicChampsSearch'>
                        <Input
                            placeholder='Buscar campeonatos'
                            onChange={e => props.searchChamp(e.target.value)}
                            className='sharedInput'
                        />
                    </div>
                </div>
                <List
                    grid={{
                        gutter: 16, //column: 4 
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 3,
                        xl: 4,
                        xxl: 6,
                    }}
                    dataSource={props.arrayOfChamps}
                    loading={props.loading}
                    pagination={{ pageSize: 4 }}
                    locale={{ emptyText: 'Nenhum campeonato encontrado' }}
                    renderItem={champ => (
                        <List.Item>
                            <Link to={`/champ?id=${champ.__key}`}>
                                <Card title={champ.nome}>
                                    <div className='publicChampsCardImg' style={{ backgroundImage: `url(${champ.img})` }} />
                                </Card>
                            </Link>
                        </List.Item>
                    )}
                />
            </div>
            <div style={{ clear: 'both', marginBottom: '50px' }}></div>

            {/* 
            <Modal
                title={'Inscrição de equipe | ' + props.champChoosed.nome}
                visible={props.modalTeamRegistration}
                onCancel={props.closeModalTeamRegistration}
                width='600px'
                footer={[
                    <Button key='close' onClick={props.closeModalTeamRegistration}>Fechar</Button>
                ]}
            >
                <RegistrationTeamForm
                    arrayOfTeams={props.arrayOfTeams}
                    champInfo={props.champChoosed}
                    quadroDePesos={props.quadroDePesos}
                />
            </Modal>

            */}
        </div>
    )
}

export default PublicChampsView